module.exports = __webpack_public_path__ + "img/tenteki.f134be38.png";